module.exports = __webpack_public_path__ + "img/bulk-transfer.d17291dd.svg";